<template>
  <!-- :color="mybackground" -->
  <v-card v-resize="onResize" class="d-flex" height="165">
    <v-card-text class="pa-0">
      <v-list-item three-line>
        <v-list-item-avatar>
          <!-- <v-img :src="'https://cdn.vuetifyjs.com/images/lists/3.jpg'"></v-img> -->
          <!-- <v-img :src="'@/assets/avatar_man.png'"></v-img> -->
          <v-img :src="image_src" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>{{ line1 }}</v-list-item-subtitle>
          <v-list-item-title>{{ line2 }}</v-list-item-title>
          <v-list-item-subtitle>{{ line3 }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
          <v-btn
            class="mt-n2 mr-n2"
            fab
            x-small
            outlined
            color="teal"
            @click="showClientDetails(client)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <!-- <v-btn class="ma-2" x-small tile outlined color="success">
            <v-icon x-small left>mdi-pencil</v-icon>Edit
          </v-btn>-->
        </v-list-item-icon>
      </v-list-item>
      <span class="ml-4">projects:</span>
      <v-card-text class="mt-n6">
        <v-sheet color="rgba(0, 0, 0, .00)" class="bbb pa-0 pl-2 ma-0">
          <v-select
            height="25px"
            v-model="selectedProject"
            :items="getProjects()"
            item-text="types"
            item-value="pid"
            hide-details
            append-outer-icon="mdi-open-in-new"
            @click:append-outer="showProject"
          ></v-select>
        </v-sheet>
      </v-card-text>
    </v-card-text>
  </v-card>
</template>


<script>
//import DialogTypesList from "./DialogTypesList";
import { getFormattedDate, getFormattedValue } from "../../shared.js";

export default {
  name: "ClientItem",
  props: {
    client: Object,
    inFilteredMode: Boolean
  },
  data() {
    return {
      showingAllTypes: false,
      selectedProject: undefined,
      image_src: require("../../assets/avatar_man.jpg")
      // projects: [
      //   {
      //     projectID: "E-003",
      //     pid: "esUo9TGvoCckjEPQ3ClI",
      //     dateAccepted: "23 Mar 2015",
      //     types: "Single Story Extension"
      //   },
      //   {
      //     projectID: "P-002",
      //     pid: "esUo9TGvoCckjEPQ3ClI",
      //     dateAccepted: "5 May 2020",
      //     types: "Loft Conversion"
      //   }
      // ]
    };
  },
  computed: {
    getPath() {
      return "../assets/avatar_man.png";
      //return require("../assets/avatar_man.png");
    },
    line1() {
      return `${this.client.addressLine1}, ${this.client.city}`;
    },
    line2() {
      return `${this.client.firstName} ${this.client.lastName}`;
    },
    line3() {
      return `${this.client.postcode || "no postcode"} - ${this.client
        .telMobile || "no mobile"}`;
    },
    mybackground() {
      return "#5f564c"; // "client-background";
    }
  },
  methods: {
    onResize() {
      //this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      //this.windowSize = { x: this.$el.clientWidth, y: this.$el.clientHeight };
    },
    // formatDate(date) {
    //   if (date) return getFormattedDate(date);
    //   else return "n/a";
    // },
    showClientDetails(client) {
      this.$emit("showClientDetails", client);
    },
    getProjects() {
      let cid = this.client.cid;
      let projects = this.$store.getters.getRelatedProjects(cid);
      if (projects.length > 0) this.selectedProject = projects[0];
      return projects;
    },
    showProject() {
      console.log("show");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.client-background {
  background: $client-background; // unfortunately this doesn't work for some reason...
}

.v-select {
  font-size: 0.9em !important;
}

// .v-text-field input {
//   font-size: 0.8em;
// }

// .one-edge-shadow {
//   -webkit-box-shadow: 0 8px 6px -6px #dcdcdc;
//   -moz-box-shadow: 0 8px 6px -6px #dcdcdc;
//   box-shadow: 0 8px 6px -6px #dcdcdc;
// }
</style>

  